import InView from 'inview';
import { CountUp } from 'countup.js/dist/countUp.umd';

const initStats = () => {
	const stats = document.querySelectorAll('.js-counter');
	stats.forEach((stat) => {
		InView(stat, (isInView) => {
			if (isInView) {
				const { number } = stat.dataset;
				if (number) {
					let decimalPlaces = 0;
					const decimalIndex = number.indexOf('.');
					if (decimalIndex > 0) {
						decimalPlaces = number.length - decimalIndex - 1;
					}

					const options = {
						decimalPlaces,
					};

					const countUp = new CountUp(stat, number, options);
					countUp.start();
				}
			}
		});
	});
};

initStats();

// Initialize dynamic block preview (editor).
if (window.acf) {
	window.acf.addAction('render_block_preview/type=stats', initStats);
}
